"use strict";
var ReactRootIndexInjection = {
  /**
   * @param {function} _createReactRootIndex
   */
  injectCreateReactRootIndex: function(_createReactRootIndex) {
    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
  }
};
var ReactRootIndex = {
  createReactRootIndex: null,
  injection: ReactRootIndexInjection
};
module.exports = ReactRootIndex;
